<style src="css/evaluate.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <div class="topbar-wrapper">
            <div class="topbar">
                <span class="back" @click="back"></span>
                评价
            </div>
        </div>
        <div class="topBg"></div>
        <div class="mainBox">
            <div class="mainTitle">总体评价</div>
            <div class="starBox">
                <div class="star" v-for="item in star"></div>
            </div>
            <div class="line"></div>
            <div class="title">描述一下感受</div>
            <div class="textareaBox">
                <textarea v-model="content" maxlength="200" disabled></textarea>
<!--                <div class="numBox">{{content.length}}/200</div>-->
            </div>
        </div>
<!--        <div class="btnBox">发表评价</div>-->
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                star:5,
                content:'',
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

            back() {
                history.back()
            },
        },
        destroyed(){

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/evaluate.vue